import { Component, Input, OnInit } from '@angular/core';
import { RepoSettingsService } from '../../../../data/repositories/repo-settings.service';
import { LeadsService } from './../../../../core/services/leads.service';
import { LeadStatusType } from './../../../../data/models'; // Hybrid Services

@Component({
    selector: 'app-sidebar2-subpanel-leads',
    templateUrl: './sidebar2-subpanel-leads.component.html',
    standalone: false,
})
export class Sidebar2SubpanelLeadsComponent implements OnInit {
    @Input() routeLessPanels: any;

    parentRoute: any = 'leads';
    // @ts-ignore TS2564
    statuses: LeadStatusType[];
    // @ts-ignore TS2564
    total: number;
    allChecked = true;

    dropdownOpen: any = true;
    DELIMITER = '|';

    // to disable filters
    disableFilter = false;

    constructor(
        private settings: RepoSettingsService,
        private leadsService: LeadsService
    ) {}

    ngOnInit() {
        // Subscribe to status query.
        this.getUserLeadsStatuses();
        this.leadsService.$leadsFilterDisabled.subscribe((val) => {
            this.disableFilter = val;
        });
    }

    headerLink() {
        this.dropdownOpen = !this.dropdownOpen;
        //
    }

    getUserLeadsStatuses() {
        this.leadsService.getStatusQuantities().subscribe((res) => {
            this.statuses = res.data.leadStatusesWithCount;
            const storedUserLeadsStatus = JSON.parse(this.settings.NavigationV2LeadsStatusSelections);
            this.total = 0;
            this.statuses.forEach((i: LeadStatusType) => {
                this.total += i.count;
                i.selected = storedUserLeadsStatus.indexOf(i.status) !== -1;
            });
            this.allChecked = storedUserLeadsStatus.indexOf('All') !== -1;
        });
    }

    // @ts-ignore TS7006
    toggleAll(evt) {
        this.allChecked = evt.target.checked;
        const storedUserLeadsStatus = [];
        // Toggle all if we selected that.
        if (evt.target.checked) {
            this.statuses.forEach((i) => {
                i.selected = true;
                storedUserLeadsStatus.push(i.status);
            });
            storedUserLeadsStatus.unshift('All');
        } else {
            this.statuses.forEach((i) => {
                i.selected = false;
            });
        }

        this.settings.NavigationV2LeadsStatusSelections = JSON.stringify(storedUserLeadsStatus);
        // Now update the service to redraw the list of leads filtering by status
        this.leadsService.getLeadsFilterStatus();
    }

    // @ts-ignore TS7006
    toggleSelection(evt) {
        const checked: boolean = evt.target.checked;
        const storedUserLeadsStatus: any = JSON.parse(this.settings.NavigationV2LeadsStatusSelections);
        const statusIndex: number = this.statuses.findIndex((item) => {
            return item.status === evt.target.value;
        });
        // @ts-ignore TS2532
        this.statuses[statusIndex]['selected'] = checked;

        // Toggle All to off when we adjust any of the items
        if (!checked) {
            if (storedUserLeadsStatus[0] === 'All') {
                storedUserLeadsStatus.splice(0, 1);
            }
            this.allChecked = false;
        }

        const selectionIndex: number = storedUserLeadsStatus.indexOf(evt.target.value);
        if (selectionIndex !== -1) {
            storedUserLeadsStatus.splice(selectionIndex, 1);
        } else {
            storedUserLeadsStatus.push(evt.target.value);
        }

        this.settings.NavigationV2LeadsStatusSelections = JSON.stringify(storedUserLeadsStatus);
        // Now update the service to redraw the list of leads filtering by status
        this.leadsService.getLeadsFilterStatus();
    }
}
